export default "__VITE_ASSET__1db9d84b__"